import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/atlassian/pipelines/agent/build/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/(sections)/PAMCtaSection/pam-cta.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/(sections)/PAMHeroSection/heroImage.png");
;
import(/* webpackMode: "eager", webpackExports: ["PAMPosts"] */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/(sections)/PAMPostsSection/PAMPosts/index.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/1_PRIMEXTB170124_Large.png");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/10_PrimeXBT-2024-Dai-cach-mang-voi-so-du-da-tai-san-dam-bao-cho-giao-dich-thuan-loi.jpg.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/100kBTC.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/105_PrimeXBT-Amongst-The-5-Best-Crypto-Trading-Platforms.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/11_436921.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/112_PrimeXBT.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/117_Traders.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/118_argentina-criptomonedas.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/121_claves-elegir-exchange-bitcoin-argentina.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/126_PrimeXBT_1.png");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/127_Copia-de-ab-3-3.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/129_Criptomoedas-sobre-graficos.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/13_IMAGE 2024-02-12 16_30_16.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/130_BFE1F027-D9A4-4C47-93AC-AC6DD170EA22.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/132_social_media_share.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/133_sem-titulo_27.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/134_img.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/135_trading-comercio-unsplash.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/14_e0bfdd1e-a0e3-46de-8fa8-dfa71a46f1ca.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/145_PrimeXBT-Matthew-Hayward-Senior-Market-Analyst.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/15_z_SyKBnA.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/152_photo-1651176118867-f4ac0b1d6da4.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/153_An-image-depicting-an-alert-for-Bitcoin-bulls-with-mining-data-predicting-a-massive-rally.-Show-the-Bitcoin-logo-prominently-with-visuals-of-mining-r.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/156_DALL·E-2024-09-03-06.37.43-An-illustration-depicting-the-topic-Analyst-Predicts-Bitcoin-May-Hit-Lows-This-Month-Before-Q4-Rally.-The-scene-shows-a-Bitcoin-symbol-in-the-center.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/159_cripto-ia.png");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/16_primexbt-operaciones-flexibles-con-tarifas-ultra-bajas-20240209-1753381.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/160_PrimeXBT_2.png");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/162_3-alternativas-a-la-plataforma-de-trading-de-criptomonedas-Binance-en-Mexico.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/166_real_b5f53418-ad70-4c52-b705-90b636e7179a.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/173_prime1.png");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/174_52344.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/18_prime.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/2_3363ccfe35596ce876622cde4bdbb2ab.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/201_criptomoedas-bitcoin.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/202_7FXTRUNOOJDIZOKJDFVXFBOPGY.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/214_investing_300X300.png");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/22_2024-03-06-09.41.41.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/23_Screenshot-2024-03-04-at-8.55.52-AM.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/24_IMAGE 2024-03-28 18_37_06.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/25_1709307976-adobestock_483999721.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/27_pexels-worldspectrum-844127.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/29_PrimeXBT-Trading-RSI.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/3_iStock-1403389740-1.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/30_20240314170316_68d7d579d59c1ebfc7db2bfda80556242e94d76c84d56b139c89ad19ed7ed0a8.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/31_primexbt-ile-bitcoin-yarilanmasindan-nasil-faydalanilir.png");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/32_builink-primexbt.jpg.optimal.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/33_11-163.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/34_1784137.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/35_EN_Blog-Revpands_1600x900_01.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/36_real_06b0f4d9-f6eb-485c-ae0f-a174c835683e.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/37_47610.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/38_1712568021-adobestock_723464387.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/39_photo_2024-04-02_11-42-58-3.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/4_shutterstock_1269296116-1-1.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/40_photo_2024-04-17_17-05-24.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/41_667d58f8fbe8d27ec1b25590ea9c5789.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/42_how_spot_Bitcoin_ETFs_have_changed_the_Crypto_trading_industry-1.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/44_PrimeXBT.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/45_V4FAQ7HWKRDFVATXUI47SHMJ5U.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/46_1712948064139822.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/48_35-2.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/49_Cryptocurrencies_800x533_L_1556444856.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/5_IMAGE 2024-01-22 15_28_29.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/58_LYNXNPEC410B3_L.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/6_1_kanchanara_esgcpjslrqs_unsplash-34527334.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/63_49201.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/67_2c72787c55bc350a81632dc5585f9cda.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/79_1718738421974.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/7mln.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/92_PRIMEXBT.png");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/barchart-og.png");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/bitcoinBrakesGlass.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/blackFlippedWithPhone.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/bloqueGenesis.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/bluePXBTwithCoins.png");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/brokenCoin.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/bullAndBear.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/candlesDogeCoin.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/caseWithBitcoins.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/chaoticTabs.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/cryptoBlackKeyboard.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/crystals.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/cubesEth.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/default.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/defaultBlue.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/defaultStyled.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/deposit3d.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/flippedCoins.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/flippedCoinsAlt.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/flippedCoinsAltStyled.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/girlBallPhoneCoins.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/glassGear.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/goldBars.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/manTradingWithProfitBlue.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/packedCoin.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/phoneFilledByCoins.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/phoneGoldMarket.png");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/primexbtBuiltForTraders.jpeg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/primexbtFancyGraphs.png");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/primexbtGoldSilverWithCityBG.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/primexbtGoldUSDZAR.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/primexbtPhoneMarkets.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/primexbtProfitAndLoss.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/primexbtProfitAndLossRed.webp");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/primexbtSilverGold.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/rewards.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/southAfricaFlag.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/USDTandUSDC.jpg");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/valuesDogeCoin.jpeg");
;
import(/* webpackMode: "eager", webpackExports: ["AnimatedText"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/animations/animated-text.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppearInView"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/animations/AppearInView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HideOnQueryParam"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/HideOnQueryParam/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NBSP"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/I18nSubstitutions/index.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/Icons/IconCurvedArrow/IconCurvedArrow.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/layout/Section/Section.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/layout/VStack/VStack.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/layout/CenterHeading/CenterHeading.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Logo"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/Logo/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LinkRewardCenter","LinkSignup"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/PlatformLink/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["APKButtonShort"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/StoreButton/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FormatAmount"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/formatters/format-price.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Cta/images/afro-cta.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Cta/images/arab-cta.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Cta/images/asia-cta.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Cta/images/brz-cta.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Cta/images/eur-cta.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Cta/images/mex-cta.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/assets/logo_cryptovalley.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterBottomBigLogo/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContactAndSupportButton"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterContactsAndSocialsSection/ContactAndSupportButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterMobileAppsBlockQr"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterLeftActionGroup/FooterMobileApps/FooterMobileAppsBlockQr/index..tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterMobileAppIOSButton","FooterMobileAppAndroidButton"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterLeftActionGroup/FooterMobileApps/FooterMobileAppsButtons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterSocialLinks/icons/discord.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterSocialLinks/icons/fb-icon.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterSocialLinks/icons/instagram-icon.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterSocialLinks/icons/linked_in.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterSocialLinks/icons/reddit-icon.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterSocialLinks/icons/telegram.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterSocialLinks/icons/tiktok-icon.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterSocialLinks/icons/twitter-icon.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterSocialLinks/icons/yt-icon.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterTrustpilot/img/logo.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterTrustpilot/img/stars.png");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderActionsWithoutPromotions","HeaderCommonActions"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Header/Components/Actions/ActionsContainer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderGiftBanner"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Header/Components/Actions/GiftBanner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderInner"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Header/Components/HeaderInner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MenuCtaBlockMobileStoreButton"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Header/Components/Mobmenu/CtaBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConvertersWidget"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Header/Components/Widgets/Converters/ConvertersWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderPartners"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Header/Versions/HeaderPartners/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HelpCenter"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/HelpCenter/index.tsx");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/styles/background.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/styles/contexts.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/SectionsGroup/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/styles/button.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterSocialLinks/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterContactsAndSocialsSection/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterLayout/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterLeftActionGroup/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/styles/rtl.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterTrustpilot/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterLegalSection/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterLinksBar/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/components/FooterNav/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/styles/typography.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Footer/variants/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/BonusCard/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Header/Versions/WaitlistHeader/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/Container/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Cta/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/sections/Hero/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/layout/CardsGrid/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/PostCard/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/HeadingAccentFragment/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/(sections)/PAMPostsSection/PAMPosts/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/[lang]/press-and-media/assets/ZAtrading.png");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/Separator/Separator.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/TopIconCard/TopIconCard.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/styles/link.module.scss");
